// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar_database_prompt[data-v-1ca12ce2] {\n  color: black;\n  text-transform: none;\n  font-size: 1em;\n  font-weight: normal;\n}", ""]);
// Exports
module.exports = exports;
